import { FormLayoutGroup } from '@customerio/pluma-components/react';
import { TextField, Select } from '@/components/form';
import { useStore } from '@tanstack/react-form';
import type { FormApi } from './types';
import { INDUSTRIES, CUSTOM_INDUSTRY_OPTION_VALUE } from './constants';

const industryOptions = [
  ...INDUSTRIES.map((industry) => ({
    value: industry,
    label: industry,
  })),
  { value: CUSTOM_INDUSTRY_OPTION_VALUE, label: 'Other' },
];

interface BasicInfoFieldsProps<TFormData> {
  form: FormApi<TFormData>;
  isDisabled?: boolean;
  autoFocus?: boolean;
}

export function BasicInfoFields<
  TFormData extends { name?: string; websiteUrl?: string; industry?: string; customIndustry?: string },
>({ form, isDisabled = false, autoFocus = false }: BasicInfoFieldsProps<TFormData>) {
  const industry = useStore(form.store, (state: unknown) => (state as { values: TFormData }).values.industry);

  return (
    <>
      <FormLayoutGroup>
        <TextField
          name="name"
          api={form}
          label="Business name"
          placeholder="Enter your business name"
          isDisabled={isDisabled}
          autoFocus={autoFocus}
        />
        <TextField
          name="websiteUrl"
          api={form}
          label="Website"
          placeholder="https://example.com"
          isDisabled={isDisabled}
        />
      </FormLayoutGroup>
      <FormLayoutGroup alignItems="flex-start">
        <Select
          label="Industry"
          name="industry"
          api={form}
          isSearchable={true}
          options={industryOptions}
          placeholder="Select your industry"
          description="If your industry isn't listed, please select Other"
          isDisabled={isDisabled}
        />
        {industry === CUSTOM_INDUSTRY_OPTION_VALUE ? (
          <TextField
            name="customIndustry"
            api={form}
            label="Other industry"
            placeholder="Enter your industry"
            description=" " // Empty string maintains consistent spacing when field appears conditionally
            isDisabled={isDisabled}
          />
        ) : null}
      </FormLayoutGroup>
    </>
  );
}
